<template>
  <div class="mr-4 ml-4">
    <div class="row">
      <div class="col-12">
        <page-header
          class="page-header-family-text"
          :actions="headerActionsConfig"
          left-side-class="col-12 col-md-7"
          :page="headerConfig"
          right-side-class="col-12 col-md-5 d-flex mt-5"
        />
      </div>
    </div>
    <validation-observer ref="boyGirlInfoForm" tag="form" novalidate>
      <div class="row mt-4">
        <div class="col-md-3 ml-5">
          <span class="data-title d-block mb-2"
            >Región del Departamento de Salud:</span
          >
          <validation-provider
            v-slot="{ errors }"
            ref="healthRegionProvider"
            rules="required"
          >
            <CustomDropDown
              id="customDropDownHealtRegion"
              v-model="model.healthRegion"
              custom-error-msg="La región de salud es requerida."
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :error="errors[0]"
              :options="optionsselectHealtRegion"
              :disabled="readOnly"
            />
          </validation-provider>
        </div>
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">Fecha Parte C:</span>
          <validation-provider
            v-slot="{ errors }"
            name="partCDate"
            rules="required"
          >
            <custom-date-picker
              v-model="model.partCDate"
              :class-container="'w-100'"
              custom-error-msg="La fecha parte C es requerida."
              :error="errors[0]"
              format="dd/MMM./yyyy"
              :max-date="currentDate"
              :disabled="readOnly"
            />
          </validation-provider>
        </div>
      </div>

      <!-- INIT Información del(la) Niño(a)-->
      <icon-view
        class="mr-2 mt-5 rounded-circle icon-view-color-text"
        icon="fas fa-address-book mb-1"
        icon-background="white"
        icon-color="#FF7058"
        icon-size="16px"
        title="Información del(la) Niño(a)"
        :gradient="true"
      />
      <div class="container-form">
        <div class="row mt-4">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2"
              >Fecha de la Reunión de Transición:</span
            >
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomTransitionDate"
              rules="required"
            >
              <custom-date-picker
                v-model="model.transitionDate"
                :class-container="'w-100'"
                custom-error-msg="La fecha de la reunión de transición es requerida."
                :error="errors[0]"
                format="dd/MMM./yyyy"
                :max-date="currentDate"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Género:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomGender"
              rules="required"
            >
              <CustomDropDown
                id="customDropDownHealtRegion"
                v-model="model.gender"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El género es requerido."
                :error="errors[0]"
                :options="optionsGender"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Etnicidad:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomEtnia"
              rules="required"
            >
              <CustomDropDown
                id="customDropDownHealtRegion"
                v-model="model.ethnicity"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="La etnicidad es requerida."
                :error="errors[0]"
                :options="optionsEthnicities"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">Nombre:</span>
            <validation-provider
              v-slot="{ errors }"
              ref="firstNameProvider"
              name="validationCustomtNameBoy"
              rules="required"
            >
              <CustomInput
                id="CustomInputName"
                v-model="model.firstName"
                custom-error-msg="El nombre es requerido."
                :error="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Inicial:</span>

            <CustomInput
              id="CustomInputInitials"
              v-model="model.initials"
              :disabled="readOnly"
            />
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Apellidos:</span>
            <validation-provider
              v-slot="{ errors }"
              ref="lastNameProvider"
              name="validationCustomInputLastNameBoy"
              rules="required"
            >
              <CustomInput
                id="CustomInputLastName"
                v-model="model.lastNames"
                custom-error-msg="El(los) apellido(s) es(son) requerido(s)."
                :error="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Fecha de Nacimiento:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomBornDate"
              rules="required"
            >
              <custom-date-picker
                v-model="model.bornDate"
                :class-container="'w-100'"
                custom-error-msg="La fecha de nacimiento es requerida."
                :error="errors[0]"
                :max-date="currentDate"
                format="dd/MMM./yyyy"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>

          <div class="col-md-4">
            <div class="">
              <span class="data-title d-block mb-2">Edad a la Transición:</span>
              <p>{{ calculateAge }}</p>
              <div
                v-if="!ageIsValid"
                class="w-100 text-left text-error start-referral-custom-error"
              >
                <div class="d-inline">
                  <em class="fa fa-times-circle"></em>
                </div>
                <p class="text-left d-inline">
                  La edad mínima del niño(a) permitida es de
                  {{ minimumAge }} años.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2"
              >Número de Seguro Social:</span
            >
            <div class="row">
              <custom-input
                id="CustomInputSsnStartReferral"
                v-show="!showSsn"
                :value="maskedStudentSsn"
                :error="customSsnErrors[0]"
                :disabled="readOnly"
                placeholder="xxx-xx-xxxx"
                mask-type="Encryptedssn"
                maxlength="9"
                :class="hasViewSsnPermission ? 'col-10 pr-0' : 'col-12'"
                @input="onStudentSsnChange"
              />
              <custom-input
                id="CustomInputShowSsnStartReferral"
                v-if="hasViewSsnPermission"
                v-show="showSsn"
                :value="model.studentSsn"
                :error="customSsnErrors[0]"
                :disabled="readOnly"
                placeholder="xxx-xx-xxxx"
                mask-type="Personalssn"
                maxlength="11"
                :class="hasViewSsnPermission ? 'col-10 pr-0' : 'col-12'"
                @input="onStudentSsnModelChange"
              />
              <div
                v-if="hasViewSsnPermission"
                class="col-1 d-flex align-items-center fa-lg"
              >
                <i
                  class="fa cursor-pointer pl-1"
                  @click="showSsn = !showSsn"
                  :class="[ssnMaskedClass]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <!--  Información del(los) Pariente(s)-->
    <icon-view
      class="mr-2 mt-5 rounded-circle icon-view-color-text"
      icon="fas fa-user-tag mb-1 mb-1 "
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información del(los) Pariente(s)"
      :gradient="true"
    />
    <div class="container-form">
      <validation-observer ref="parentInfoForm" v-slot="{}" tag="form">
        <div class="row mt-4">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">Nombre:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomName"
              rules="required"
            >
              <CustomInput
                id="CustomInputParentFirstName"
                v-model="model.parentFirstName"
                :error="errors[0]"
                custom-error-msg="El nombre del pariente es requerido."
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Apellidos:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomInputLastName"
              rules="required"
            >
              <CustomInput
                id="CustomInputParentLastName"
                :error="errors[0]"
                custom-error-msg="El(los) apellido(s) es(son) requerido(s)."
                v-model="model.parentLastNames"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Parentesco:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomParent"
              rules="required"
            >
              <CustomDropDown
                id="customDropDownHealtRegion"
                v-model="model.relationship"
                :error="errors[0]"
                custom-error-msg="El parentesco es requerido."
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :options="optionsRelationships"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">Correo Electrónico:</span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                email: 'El correo electrónico no es válido.',
                required: 'El correo electrónico es requerido.'
              }"
              name="validationEmail"
              rules="required|email"
            >
              <CustomInput
                id="CustomInputEmailParent"
                :error="errors[0]"
                v-model="model.parentEmail"
                type="email"
                :custom-error-msg="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Teléfono 1:</span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                completePhone: 'Número teléfonico completo es requerido',
                required: 'El telefóno 1 es requerido.'
              }"
              name="validationCustomInputNumberPhoneOne"
              rules="required|completePhone"
            >
              <CustomInput
                id="CustomInputNumberPhoneOne"
                v-model="model.parentPhoneOne"
                mask-type="Phone"
                :masked="false"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Teléfono 2:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomInputNumberPhoneTwo"
              rules="completePhone"
            >
              <CustomInput
                id="CustomInputNumberPhoneTwo"
                v-model="model.parentPhoneTwo"
                :error="errors[0]"
                mask-type="Phone"
                :masked="false"
                :disabled="readOnly"
                custom-error-msg="Número teléfonico completo es requerido."
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
    </div>
    <!--Información de Dirección(es)-->
    <icon-view
      class="mr-2 mt-5 rounded-circle icon-view-color-text"
      icon="fas fa-map-marker-alt mb-1 mb-1 "
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información de Dirección(es)"
      :gradient="true"
    />
    <!--tipo fisico-->
    <div class="container-form">
      <div class="mt-4">
        <span class="data-title d-block mb-2 font-1">Tipo:</span>
        <strong class="font-16">Física</strong>
      </div>
      <validation-observer ref="adressInfoForm" v-slot="{}" tag="form">
        <div class="row mt-4">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">Dirección (Línea 1):</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomAddressOne"
              rules="required"
            >
              <CustomInput
                id="CustomInputAddressOne"
                v-model="physicalAddress.addressLine1"
                :error="errors[0]"
                :disabled="readOnly"
                custom-error-msg="La dirección (línea 1) es requerida."
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Dirección (Línea 2):</span>

            <CustomInput
              id="CustomInputAddressTwo"
              v-model="physicalAddress.addressLine2"
              :disabled="readOnly"
            />
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Municipio:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomMunicipes"
              rules="required"
            >
              <CustomDropDown
                id="customDropDownMunicipaties"
                :error="errors[0]"
                custom-error-msg="El municipio es requerido."
                v-model="physicalAddress.municipality"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :options="optionsMunicipalities"
                :disabled="readOnly"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">Código Postal:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomPostal"
              rules="required|min:5|max:10"
              :custom-messages="{
                min: 'El código postal no es valido.',
                max: 'El código postal no es valido.',
                required: 'El código postal es requerido.'
              }"
            >
              <CustomInput
                id="CustomInputPostal"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                mask-type="PostalCode"
                placeholder="xxxxx-xxxx"
                v-model="physicalAddress.zipcode"
                :disabled="readOnly"
                minlength="5"
                maxlength="9"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>
    </div>
    <!--tipo postal-->
    <div class="container-form">
      <div class="mt-3">
        <span class="data-title d-block mb-2 font-1">Tipo:</span>
        <strong class="font-16">Postal</strong>
      </div>

      <validation-observer ref="adressInfoPostalForm" v-slot="{}" tag="form">
        <div class="row mt-4">
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">Dirección (Línea 1):</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomaddressPostalOne"
              rules="required"
            >
              <input
                v-if="disabledPostal"
                id="customPostalAddressLine1Disabled"
                type="text"
                class="form-control"
                disabled
                :value="postalAddress.addressLine1"
              />
              <CustomInput
                v-else
                id="CustomInputNumbeOnePostal"
                v-model="postalAddress.addressLine1"
                :error="errors[0]"
                custom-error-msg="La dirección (línea 1) es requerida."
                type="text"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Dirección (Línea 2):</span>
            <validation-provider name="validationCustomaddressPostalTwo">
              <input
                v-if="disabledPostal"
                id="customPostalAddressLine2Disabled"
                type="text"
                class="form-control"
                disabled
                :value="postalAddress.addressLine2"
              />
              <CustomInput
                v-else
                id="CustomInputAddresTwoPostal"
                v-model="postalAddress.addressLine2"
                type="text"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <span class="data-title d-block mb-2">Municipio:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomMunicipalitiesPostalTwo"
              rules="required"
            >
              <CustomDropDown
                id="customDropDownMunicipalitiesTwo"
                v-model="postalAddress.municipality"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :error="errors[0]"
                custom-error-msg="El municipio es requerido."
                :disabled="disabledPostal"
                :options="optionsMunicipalities"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <span class="data-title d-block mb-2">Código Postal:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomPostalCodeTwo"
              rules="required|min:5|max:10"
              :custom-messages="{
                min: 'El código postal no es valido.',
                max: 'El código postal no es valido.',
                required: 'El código postal es requerido.'
              }"
            >
              <input
                v-if="disabledPostal"
                id="customPostalEmailDisabled"
                type="text"
                class="form-control"
                disabled
                :value="postalAddress.zipcode"
              />
              <CustomInput
                v-else
                id="postalCodeTwo"
                mask-type="PostalCode"
                placeholder="xxxxx-xxxx"
                v-model="postalAddress.zipcode"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                type="text"
                minlength="5"
                maxlength="9"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 mb-3">
            <CheckBox
              v-model="isPostalSameAsPhysical"
              @input="setValuesFromPhysical"
              class="font-weight-bold text-md-nowrap mt-5"
              text="La misma dirección que la física"
            />
          </div>
        </div>
      </validation-observer>
    </div>
    <div>
      <icon-view
        class="mr-2 mt-5 rounded-circle icon-view-color-text"
        icon="fas fa-comment mb-1 mb-1 "
        icon-background="white"
        icon-color="#FF7058"
        icon-size="16px"
        title="Información Adicional"
        :gradient="true"
      />
      <div class="container-form mt-2">
        <custom-text-area
          v-model="model.additionalComment"
          label="Comentario:"
          :maxlength="3000"
          show-char-count
          :count-classes="['d-block text-right']"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import CustomDropDown from "@/components/common/CustomDropDown";
import CustomDatePicker from "custom-date-picker";
import CustomInput from "CustomInput";
import IconView from "icon-view";
import CheckBox from "CheckBox";
import CustomTextArea from "CustomTextArea";
import StudentServices from "@/services/pc/referral-student";
import mixAlert from "@/mixin/alert.mixin";
import store from "@/store/index";
import dateUtil from "@/utils/dateUtil.js";
import Ages from "@/utils/constants/student/partCpartBAges";

export default {
  name: "startReferral",
  mixins: [mixAlert],
  components: {
    PageHeader,
    CustomDropDown,
    CustomInput,
    CustomDatePicker,
    IconView,
    CheckBox,
    CustomTextArea
  },
  data() {
    return {
      isEnable: false,
      readOnly: false,
      showSsn: false,
      ageIsValid: true,
      currentDate: new Date(),
      optionsEthnicities: [],
      optionsselectHealtRegion: [],
      optionsGender: [],
      optionsRelationships: [],
      optionsMunicipalities: [],
      customSsnErrors: [],
      maskedStudentSsn: null,
      model: {
        pcStudentId: null,
        caseNumber: null,
        healthRegion: null,
        regionId: null,
        transitionDate: null,
        studentSsn: null,
        firstName: null,
        initials: null,
        lastNames: null,
        bornDate: null,
        age: null,
        gender: null,
        genderId: null,
        ethnicity: null,
        ethnicityId: null,
        parentFirstName: null,
        parentLastNames: null,
        relationship: null,
        relationshipId: null,
        parentEmail: null,
        parentPhoneOne: null,
        parentPhoneTwo: null,
        partCDate: null,
        additionalComment: null
      },
      physicalAddress: {
        addressLine1: null,
        addressLine2: null,
        municipality: null,
        zipcode: null
      },
      postalAddress: {
        addressLine1: null,
        addressLine2: null,
        municipality: null,
        zipcode: null
      },
      isPostalSameAsPhysical: false
    };
  },
  mounted() {
    this.optionsselectHealtRegion = this.userHealthRegions;

    if (this.userHealthRegions.length === 1) {
      this.model.healthRegion = {
        ...this.userHealthRegions[0],
        disabled: true
      };
    }

    StudentServices.getStudentSelect().then(({ data }) => {
      const dataRoute = data;
      this.optionsEthnicities = dataRoute.ethnicities;
      this.optionsGender = dataRoute.genders;
      this.optionsRelationships = dataRoute.relationships;
      this.optionsMunicipalities = dataRoute.municipalities;
    });
  },
  computed: {
    minimumAge() {
      return Ages.MINIMUM_AGE;
    },
    maximumAge() {
      return Ages.MAXIMUM_AGE;
    },
    validationAge() {
      return Ages.VALIDATION_AGE;
    },
    calculateAge() {
      let age = dateUtil.calculateAge(this.model.bornDate);

      if (this.model.bornDate != null) {
        this.ageIsValid = age >= this.minimumAge;
      }
      if (age == 0) return "-";

      return age.toFixed(2);
    },
    headerConfig() {
      return {
        title: "Comenzar Proceso del Referido",
        icon: "fas fa-user-circle",
        routes: ["Inicio", "Estudiante", "Comenzar Referido"]
      };
    },
    headerActionsConfig() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left pr-1",
          variant: "outline-success",
          click: () => {
            this.$router.go(-1);
          }
        },
        {
          text: "Guardar",
          icon: "fas fa-save  pr-1",
          variant: "success",
          visible: !this.readOnly,
          click: () => {
            this.save();
          }
        },
        {
          text: "Someter",
          icon: "fas fa-flag pr-1",
          variant: "success",
          visible: this.canSubmit && !this.readOnly,
          click: () => {
            this.submit();
          }
        }
      ];
    },
    canSubmit() {
      return store.getters.HasPermission("student.referralcparttobpart.submit");
    },
    userHealthRegions() {
      return store.getters["$_user/healthRegions"] || [];
    },
    ssnMaskedClass() {
      return this.showSsn ? "fa-eye" : "fa-eye-slash";
    },
    hasViewSsnPermission() {
      return store.getters.HasPermission("student.partcpartbreferral.viewssn");
    },
    disabledPostal() {
      return this.isPostalSameAsPhysical || this.readOnly;
    }
  },
  methods: {
    onStudentSsnChange({ internalValue, encryptedValue }) {
      this.maskedStudentSsn = encryptedValue;
      this.model.studentSsn = internalValue;
    },
    onStudentSsnModelChange(newValue) {
      if (!newValue) {
        this.model.studentSsn = null;
        this.maskedStudentSsn = null;
        return;
      }

      const cleanVal = newValue.replace(/-/g, "");
      this.model.studentSsn = cleanVal;
      this.maskedStudentSsn = this.transformSsnDisplay(cleanVal);
    },
    transformSsnDisplay(val = "") {
      let displayVal = val.replace(/[^0-9|\\•]/g, "");
      displayVal = displayVal.substr(0, 9);
      if (displayVal.length < 6) return displayVal.replace(/[0-9]/g, "•");
      else return "•".repeat(5) + val.slice(5);
    },
    setModelForSave() {
      this.model.regionId = this.model.healthRegion?.id;
      this.model.genderId = this.model.gender?.id;
      this.model.ethnicityId = this.model.ethnicity?.id;
      this.model.age =
        !this.calculateAge || this.calculateAge == "-"
          ? null
          : Number(this.calculateAge);
      this.model.relationshipId = this.model.relationship?.id;

      this.model.physicalAddressLineOne = this.physicalAddress.addressLine1;
      this.model.physicalAddressLineTwo = this.physicalAddress.addressLine2;
      this.model.physicalAddressMunicipalityId = this.physicalAddress.municipality?.id;
      this.model.physicalAddressPostalCode = this.physicalAddress.zipcode;

      this.model.postalAddressLineOne = this.postalAddress.addressLine1;
      this.model.postalAddressLineTwo = this.postalAddress.addressLine2;
      this.model.postalAddressMunicipalityId = this.postalAddress.municipality?.id;
      this.model.postalAddressPostalCode = this.postalAddress.zipcode;
    },
    customSsnValidate() {
      this.customSsnErrors = [];
      let isValidSsn =
        this.model.studentSsn === null || this.model.studentSsn?.length === 9;

      if (!isValidSsn)
        this.customSsnErrors.push("El número de seguro social es requerido");

      return isValidSsn;
    },
    async save() {
      const isHealthRegionValid = await this.$refs.healthRegionProvider.validate();
      const isfistNameValid = await this.$refs.firstNameProvider.validate();
      const isLastNameValid = await this.$refs.lastNameProvider.validate();
      const isSsnValid = this.customSsnValidate();

      if (
        isSsnValid &&
        isHealthRegionValid.valid &&
        isfistNameValid.valid &&
        isLastNameValid.valid &&
        this.ageIsValid
      ) {
        let response = await this.ShowCancelModal(
          "Atención",
          "¿Está seguro(a) que desea guardar la información presentada?",
          "Sí",
          "No"
        );

        if (response) {
          this.setModelForSave();

          StudentServices.save(this.model)
            .then(({ data }) => {
              this.model.pcStudentId = data;
              this.ShowToast(
                "Alerta",
                "La Información ha sido guardada exitosamente.",
                "success"
              );
              setTimeout(
                () =>
                  this.$router.push({
                    name: "detailReferral",
                    params: { pcStudentId: this.model.pcStudentId }
                  }),
                1500
              );
            })
            .catch(err =>
              this.ShowToast("Alerta", err.response.data.message, "error")
            );
        }
      }
    },
    async submit() {
      const isSsnValid = this.customSsnValidate();
      const boyIsValid = await this.$refs.parentInfoForm.validate();
      const parentIsValid = await this.$refs.boyGirlInfoForm.validate();
      const addressValid = await this.$refs.adressInfoForm.validate();
      const addressPostalValid = await this.$refs.adressInfoPostalForm.validate();

      const healthRegionValid = await this.$refs.healthRegionProvider.validate();

      const isValid = this.allIsComplete(
        boyIsValid,
        parentIsValid,
        addressValid,
        addressPostalValid,
        isSsnValid
      );

      if (this.calculateAge >= this.maximumAge && isValid) {
        await this.ShowAlertModal(
          "Atención",
          "No es posible someter la solicitud ya que el estudiante cuenta con más de la Edad permitida en el referido de salud."
        );
        return;
      } else if (
        this.calculateAge >= this.validationAge &&
        this.calculateAge <= this.maximumAge &&
        isValid
      ) {
        let ageResponse = await this.ShowCancelModal(
          "Confirmación",
          "La edad documentada se encuentra fuera de término, ¿Está seguro(a) que desea someter la solicitud?",
          "Sí",
          "No"
        );
        if (!ageResponse) return;
      }

      if (healthRegionValid.valid && isValid && this.ageIsValid) {
        let response = await this.ShowCancelModal(
          "Atención",
          "¿Está seguro(a) que desea someter la información presentada?",
          "Sí",
          "No"
        );
        if (response) {
          this.setModelForSave();
          await StudentServices.submit(this.model)
            .then(({ data }) => {
              this.readOnly = true;
              this.model.pcStudentId = data;

              this.ShowToast(
                "Alerta",
                "La información ha sido sometida exitosamente.",
                "success"
              );

              setTimeout(
                () =>
                  this.$router.push({
                    name: "detailReferral",
                    params: { pcStudentId: this.model.pcStudentId }
                  }),
                1500
              );
            })
            .catch(err =>
              this.ShowToast("Alerta", err.response.data.message, "error")
            );
        }
      } else {
        this.ShowToast(
          "Alerta",
          "Favor completar la Información solicitada.",
          "error"
        );
      }
    },
    allIsComplete(a, b, c, d, e) {
      return a && b && c && d && e;
    },
    setValuesFromPhysical(value) {
      this.$refs.adressInfoPostalForm.reset();
      this.postalAddress = value
        ? { ...this.physicalAddress }
        : {
            addressLine1: null,
            addressLine2: null,
            municipality: null,
            zipcode: null
          };
    }
  },
  watch: {
    physicalAddress: {
      deep: true,
      handler(value) {
        if (this.isPostalSameAsPhysical) this.setValuesFromPhysical(true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-view-color-text {
  ::v-deep .color-gray-7 {
    color: #11291b !important;
  }

  ::v-deep .dot--has-border {
    border-style: solid;
    border-width: 17px !important;
    border-color: #fff;
  }
}
.cursor-pointer {
  cursor: pointer;
}

.start-referral-custom-error em {
  font-size: 18px;
  padding-right: 10px;
}
.start-referral-custom-error p {
  font-size: 14px;
}
.container-form {
  margin-left: 56px;
}
</style>
